import * as DICT from "@/utils/dict"

export default {
    install(Vue, option) {
        Vue.prototype.$DICT = DICT
    }
}